'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

const ShieldCheckIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
  </svg>;


const CartIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
  </svg>;


const ArrowRightIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>;


const PrinterIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
  </svg>;


const FunnelIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
  </svg>;


interface Product {
  id: string;
  href: string;
  image: string;
  imageAlt: string;
  badge: string;
  badgeStyle: string;
  savePct: number;
  grade: string;
  gradeStyle: string;
  category: string;
  stock: string;
  stockStyle: string;
  title: string;
  desc: string;
  price: string;
  comparePrice: string;
  priceColor: string;
  btnStyle: string;
  btnHover: string;
  functions: string[];
  funcStyle: string;
  bgGradient: string;
}

const officeProducts: Product[] = [
{
  id: 'RFP-023-LASERJET3001DW',
  href: '/products/hp-laserjet-3001dw-refurbished/',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a0c87064-1780400858076.png",
  imageAlt: 'Refurbished HP LaserJet 3001dw monochrome laser printer for office use',
  badge: 'Refurbished',
  badgeStyle: 'bg-red-50 text-red-600 ring-red-100',
  savePct: 48,
  grade: 'Grade C',
  gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
  category: 'Office Laser',
  stock: 'In stock',
  stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  title: 'Refurbished HP LaserJet 3001dw',
  desc: 'Fast monochrome laser printer for office teams with USB, Wi-Fi and mobile printing. High-volume capable.',
  price: '$129.00',
  comparePrice: '$249.00',
  priceColor: 'text-red-600',
  btnStyle: 'bg-red-600 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
  btnHover: 'hover:bg-blue-700',
  functions: ['Print only'],
  funcStyle: 'bg-red-50 text-red-600 ring-red-100',
  bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]'
},
{
  id: 'RFP-024-LASERJET3101FDW',
  href: '/products/hp-laserjet-3101fdw-refurbished/',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17e9f555c-1780400857257.png",
  imageAlt: 'Refurbished HP LaserJet 3101fdw multifunction laser printer',
  badge: 'Refurbished',
  badgeStyle: 'bg-red-50 text-red-600 ring-red-100',
  savePct: 49,
  grade: 'Grade B',
  gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
  category: 'Office Laser',
  stock: 'In stock',
  stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  title: 'Refurbished HP LaserJet 3101fdw',
  desc: 'Multifunction laser printer with print, scan, copy, fax, USB, Wi-Fi and mobile printing for busy offices.',
  price: '$169.00',
  comparePrice: '$329.00',
  priceColor: 'text-red-600',
  btnStyle: 'bg-red-600 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
  btnHover: 'hover:bg-blue-700',
  functions: ['Print', 'Scan', 'Copy', 'Fax'],
  funcStyle: 'bg-red-50 text-red-600 ring-red-100',
  bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]'
},
{
  id: 'RFP-025-LASERJET3201DW',
  href: '/products/hp-laserjet-3201dw-refurbished/',
  image: 'https://printhubsolution.com/_next/static/media/printer-025-optimized.436bff09.webp',
  imageAlt: 'Refurbished HP LaserJet 3201dw wireless laser printer',
  badge: 'Refurbished',
  badgeStyle: 'bg-red-50 text-red-600 ring-red-100',
  savePct: 50,
  grade: 'Grade A',
  gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
  category: 'Office Laser',
  stock: 'In stock',
  stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  title: 'Refurbished HP LaserJet 3201dw',
  desc: 'Wireless monochrome laser printer with USB, Wi-Fi and mobile printing. Reliable for daily office output.',
  price: '$149.00',
  comparePrice: '$299.00',
  priceColor: 'text-red-600',
  btnStyle: 'bg-red-600 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
  btnHover: 'hover:bg-blue-700',
  functions: ['Print only'],
  funcStyle: 'bg-red-50 text-red-600 ring-red-100',
  bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]'
},
{
  id: 'RFP-026-LASERJET3301FDW',
  href: '/products/hp-laserjet-3301fdw-refurbished/',
  image: 'https://printhubsolution.com/_next/static/media/printer-026-optimized.b2cf582d.webp',
  imageAlt: 'Refurbished HP LaserJet 3301fdw all-in-one laser printer with fax',
  badge: 'Refurbished',
  badgeStyle: 'bg-red-50 text-red-600 ring-red-100',
  savePct: 49,
  grade: 'Grade A',
  gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
  category: 'Office Laser',
  stock: 'Low stock',
  stockStyle: 'bg-red-50 text-red-700 ring-red-100',
  title: 'Refurbished HP LaserJet 3301fdw',
  desc: 'All-in-one laser with print, scan, copy, fax, USB, Wi-Fi and mobile printing for demanding office environments.',
  price: '$229.00',
  comparePrice: '$449.00',
  priceColor: 'text-red-600',
  btnStyle: 'bg-red-600 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
  btnHover: 'hover:bg-blue-700',
  functions: ['Print', 'Scan', 'Copy', 'Fax'],
  funcStyle: 'bg-red-50 text-red-600 ring-red-100',
  bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]'
},
{
  id: 'RFP-027-LASERJET4001DW',
  href: '/products/hp-laserjet-4001dw-refurbished/',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1169180b0-1780400859536.png",
  imageAlt: 'Refurbished HP LaserJet 4001dw high-volume laser printer',
  badge: 'Refurbished',
  badgeStyle: 'bg-red-50 text-red-600 ring-red-100',
  savePct: 46,
  grade: 'Grade B',
  gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
  category: 'Office Laser',
  stock: 'In stock',
  stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  title: 'Refurbished HP LaserJet 4001dw',
  desc: 'High-volume monochrome laser printer built for busy workgroups with fast print speeds and wireless connectivity.',
  price: '$199.00',
  comparePrice: '$369.00',
  priceColor: 'text-red-600',
  btnStyle: 'bg-red-600 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
  btnHover: 'hover:bg-blue-700',
  functions: ['Print only'],
  funcStyle: 'bg-red-50 text-red-600 ring-red-100',
  bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]'
},
{
  id: 'RFP-028-LASERJET4101FDW',
  href: '/products/hp-laserjet-4101fdw-refurbished/',
  image: 'https://printhubsolution.com/_next/static/media/printer-024-optimized.64e1af7b.webp',
  imageAlt: 'Refurbished HP LaserJet 4101fdw enterprise multifunction laser printer',
  badge: 'Refurbished',
  badgeStyle: 'bg-red-50 text-red-600 ring-red-100',
  savePct: 47,
  grade: 'Grade A',
  gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
  category: 'Office Laser',
  stock: 'In stock',
  stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  title: 'Refurbished HP LaserJet 4101fdw',
  desc: 'Enterprise-grade multifunction laser with print, scan, copy, fax and advanced security features for large offices.',
  price: '$279.00',
  comparePrice: '$529.00',
  priceColor: 'text-red-600',
  btnStyle: 'bg-red-600 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
  btnHover: 'hover:bg-blue-700',
  functions: ['Print', 'Scan', 'Copy', 'Fax'],
  funcStyle: 'bg-red-50 text-red-600 ring-red-100',
  bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]'
}];


const sortOptions = ['Featured', 'Price: Low to High', 'Price: High to Low', 'Savings %'];
const gradeFilters = ['All Grades', 'Grade A', 'Grade B', 'Grade C'];
const functionFilters = ['All Functions', 'Print only', 'Print + Scan + Copy', 'With Fax'];

export default function OfficePrintersPage() {
  const [activeGrade, setActiveGrade] = useState('All Grades');
  const [activeFunction, setActiveFunction] = useState('All Functions');
  const [sortBy, setSortBy] = useState('Featured');

  const filtered = officeProducts.filter((p) => {
    const gradeMatch = activeGrade === 'All Grades' ? true : p.grade === activeGrade;
    const fnMatch =
    activeFunction === 'All Functions' ? true :
    activeFunction === 'Print only' ? p.functions.length === 1 :
    activeFunction === 'With Fax' ? p.functions.includes('Fax') :
    p.functions.length > 1;
    return gradeMatch && fnMatch;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === 'Price: Low to High') return parseFloat(a.price.replace('$', '')) - parseFloat(b.price.replace('$', ''));
    if (sortBy === 'Price: High to Low') return parseFloat(b.price.replace('$', '')) - parseFloat(a.price.replace('$', ''));
    if (sortBy === 'Savings %') return b.savePct - a.savePct;
    return 0;
  });

  return (
    <div>
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="relative overflow-hidden bg-[radial-gradient(circle_at_18%_12%,rgba(220,38,38,0.32),transparent_34%),radial-gradient(circle_at_86%_20%,rgba(14,116,194,0.22),transparent_30%),linear-gradient(135deg,#0a0a0a_0%,#1a0505_48%,#0a0f1a_100%)] py-12 lg:py-16">
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#f87171]/35 to-transparent" />
          <div className="container">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="transition hover:text-white">Home</Link>
              <span>/</span>
              <span className="text-white">Office Printers</span>
            </nav>
            <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-2xl">
                <span className="mb-4 inline-flex w-fit rounded-full border border-[#fb7185]/35 bg-[#dc2626]/16 px-3 py-1 text-xs font-semibold tracking-[0.12em] text-[#fecdd3] uppercase">
                  Business &amp; Office
                </span>
                <h1 className="text-4xl font-semibold leading-tight text-white sm:text-5xl">
                  Office Printers
                </h1>
                <p className="mt-4 text-base leading-7 text-slate-300 sm:text-lg">
                  Work-ready refurbished laser printers for invoices, reports, shared desks, and daily office output. Built for volume and reliability.
                </p>
                <div className="mt-5 flex flex-wrap gap-3">
                  {['High Volume', 'Fast Print Speed', 'Network Ready', 'Warranty Included'].map((tag) =>
                  <span key={tag} className="rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-semibold text-slate-200">{tag}</span>
                  )}
                </div>
              </div>
              <div className="shrink-0 text-right">
                <p className="text-sm text-slate-400">Starting from</p>
                <p className="text-5xl font-semibold text-white">$129</p>
                <p className="mt-1 text-sm text-slate-400">{officeProducts.length} models available</p>
              </div>
            </div>
          </div>
        </section>

        {/* Filters + Products */}
        <section className="bg-[linear-gradient(180deg,#fff7f7_0%,#ffffff_100%)] py-10 lg:py-12">
          <div className="container">
            {/* Filter bar */}
            <div className="mb-8 space-y-3 rounded-[12px] border border-slate-200 bg-white px-5 py-4 shadow-sm">
              <div className="flex flex-wrap items-center gap-2">
                <span className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
                  <FunnelIcon />
                  Grade:
                </span>
                {gradeFilters.map((g) =>
                <button
                  key={g}
                  onClick={() => setActiveGrade(g)}
                  className={`rounded-[8px] px-3 py-1.5 text-xs font-semibold transition ${
                  activeGrade === g ?
                  'bg-[#dc2626] text-white shadow-sm' :
                  'border border-slate-200 bg-white text-slate-600 hover:border-red-200 hover:text-red-600'}`
                  }>
                  
                    {g}
                  </button>
                )}
              </div>
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm font-semibold text-slate-700">Functions:</span>
                  {functionFilters.map((f) =>
                  <button
                    key={f}
                    onClick={() => setActiveFunction(f)}
                    className={`rounded-[8px] px-3 py-1.5 text-xs font-semibold transition ${
                    activeFunction === f ?
                    'bg-slate-900 text-white shadow-sm' :
                    'border border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900'}`
                    }>
                    
                      {f}
                    </button>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-slate-700">Sort:</span>
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="rounded-[8px] border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-red-200">
                    
                    {sortOptions.map((o) => <option key={o}>{o}</option>)}
                  </select>
                  <span className="text-sm text-slate-500">{sorted.length} results</span>
                </div>
              </div>
            </div>

            {/* Products grid */}
            <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
              {sorted.map((product) =>
              <article
                key={product.id}
                className="group relative flex h-full flex-col overflow-hidden rounded-[12px] border border-red-100 bg-white shadow-[0_14px_34px_rgba(15,23,42,0.08)] transition hover:-translate-y-0.5 hover:shadow-[0_20px_48px_rgba(15,23,42,0.13)]">
                
                  <Link href={product.href} className={`relative min-h-[15rem] overflow-hidden ${product.bgGradient}`}>
                    <div className={`absolute left-3 top-3 z-20 inline-flex items-center gap-1.5 rounded-[8px] px-3 py-1.5 text-xs font-bold ring-1 ${product.badgeStyle}`}>
                      <ShieldCheckIcon />
                      {product.badge}
                    </div>
                    <span className="absolute right-3 top-3 z-20 rounded-full bg-white px-2.5 py-1 text-[10px] font-bold text-red-600 shadow-sm ring-1 ring-red-100">
                      Save {product.savePct}%
                    </span>
                    <img
                    alt={product.imageAlt}
                    src={product.image}
                    className="absolute inset-0 h-full w-full object-contain px-6 pt-12 pb-6 transition duration-300 group-hover:scale-105" />
                  
                  </Link>
                  <div className="flex flex-1 flex-col px-5 py-4">
                    <div className="flex flex-wrap gap-2">
                      <span className={`inline-flex items-center gap-1 rounded-[7px] px-2.5 py-1 text-[10px] font-bold ring-1 ${product.gradeStyle}`}>
                        <ShieldCheckIcon />
                        {product.grade}
                      </span>
                      <span className="inline-flex items-center gap-1 rounded-[7px] bg-red-50 px-2.5 py-1 text-[10px] font-bold text-red-700 ring-1 ring-red-100">
                        <PrinterIcon />
                        {product.category}
                      </span>
                      <span className={`inline-flex items-center rounded-[7px] px-2.5 py-1 text-[11px] font-bold ring-1 ${product.stockStyle}`}>
                        {product.stock}
                      </span>
                    </div>
                    <Link href={product.href}>
                      <h2 className="mt-3 line-clamp-2 text-lg font-semibold leading-tight text-slate-950 transition group-hover:text-red-600">
                        {product.title}
                      </h2>
                    </Link>
                    <p className="mt-1.5 line-clamp-2 text-sm leading-6 text-slate-600">{product.desc}</p>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {product.functions.map((fn) =>
                    <span key={fn} className={`inline-flex items-center gap-1.5 rounded-[8px] px-2.5 py-1.5 text-xs font-bold ring-1 ${product.funcStyle}`}>
                          <PrinterIcon />
                          {fn}
                        </span>
                    )}
                    </div>
                    <div className="mt-3 flex flex-wrap items-end gap-3">
                      <span className={`text-2xl font-semibold ${product.priceColor}`}>{product.price}</span>
                      <span className="pb-0.5 text-sm font-semibold text-slate-400 line-through">{product.comparePrice}</span>
                    </div>
                    <div className="mt-auto grid grid-cols-[1fr_auto] gap-3 pt-4">
                      <button
                      type="button"
                      className={`inline-flex h-11 w-full items-center justify-center gap-2 rounded-[8px] px-4 text-sm font-semibold text-white transition ${product.btnStyle} ${product.btnHover}`}>
                      
                        <CartIcon />
                        Add to Cart
                      </button>
                      <Link
                      href={product.href}
                      className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[8px] border border-red-200 bg-white text-red-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
                      aria-label={`View ${product.title}`}>
                      
                        <ArrowRightIcon />
                      </Link>
                    </div>
                  </div>
                </article>
              )}
            </div>

            {sorted.length === 0 &&
            <div className="py-20 text-center">
                <p className="text-lg font-semibold text-slate-600">No products match your filters.</p>
                <button
                onClick={() => {setActiveGrade('All Grades');setActiveFunction('All Functions');}}
                className="mt-4 text-sm font-semibold text-red-600 underline">
                
                  Clear all filters
                </button>
              </div>
            }

            {/* Browse other categories */}
            <div className="mt-12 rounded-[16px] border border-slate-200 bg-white p-8 shadow-sm">
              <h2 className="text-xl font-semibold text-slate-950">Browse Other Categories</h2>
              <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {[
                { label: 'Inkjet Printers', href: '/inkjet-printers/', desc: 'All inkjet models for home and office', color: 'text-blue-700', border: 'border-blue-100 hover:border-blue-300' },
                { label: 'Home Printers', href: '/home-printers/', desc: 'Compact printers for everyday home use', color: 'text-violet-700', border: 'border-violet-100 hover:border-violet-300' },
                { label: 'All Products', href: '/', desc: 'View our full refurbished printer range', color: 'text-slate-700', border: 'border-slate-200 hover:border-slate-400' }].
                map((cat) =>
                <Link key={cat.href} href={cat.href} className={`group flex items-center justify-between rounded-[10px] border p-4 transition ${cat.border}`}>
                    <div>
                      <p className={`font-semibold ${cat.color}`}>{cat.label}</p>
                      <p className="mt-1 text-xs text-slate-500">{cat.desc}</p>
                    </div>
                    <span className={`transition group-hover:translate-x-1 ${cat.color}`}><ArrowRightIcon /></span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>);

}